export const CHART_NO_DATA_TEXT = 'There’s no data for this time frame'
